import * as React from 'react';
import {
    CartType,
    ShoppingCartContextProvider,
    ShoppingCartContext,
    CartItem,
    Global,
    LocalStorage,
    StorableDataKeys,
} from '@weddingspot/ws-core-components';
import { Appointments } from '@weddingspot/ws-api-client';
import * as analytics from '@weddingspot/ws-analytics';
import { APP_ROOT_DOM_NODE_ID } from '../constants/config';
import { logEvent } from '@weddingspot/ws-analytics';
import { AnalyticsEvent } from '@weddingspot/ws-analytics';

/**
 * Analytics logging
 */
const onCartOpen = (sourcePage?: string) => {
    analytics.logEvent(analytics.AnalyticsEvent.EVTNM_CLICKED_SHOPPING_CART, { source: sourcePage ? sourcePage : 'SRP' });
    analytics.setCurUserProps({ name: analytics.ClarityTags.VENUES_SHOPPING_CARD, value: 'Yes' });
};

const onSubmitCTAClick = (items: CartItem[], sourcePage?: string) => {
    // TODO (apyasetskiy@cvent.com): appropriate changes needs to be applied to SRP.
    // sourcePage : 'venues SRP shopping cart', - this was left as tmp workaround
    analytics.logEvent(analytics.AnalyticsEvent.EVTNM_CLICKED_SHOPPING_CARD_SUBMIT_REQUEST_CTA, {
        source: sourcePage ? sourcePage : 'venues SRP shopping cart',
        'Venue count': items.length,
    });
};

const onSuccessfulOutreach = (request: Appointments.MassInquiryRequestParams, sourcePage?: string) => {
    analytics.logEvent(analytics.AnalyticsEvent.EVTNM_SUCCESSFUL_COUPLE_OUTREACH, {
        source: sourcePage ? sourcePage : 'venues SRP shopping cart',
        VenueCount: request.vendor_ids.length,
        ...request.venues_analytics,
    });
};

const onItemRemove = () => {
    analytics.logEvent(analytics.AnalyticsEvent.EVTNM_CLICKED_REMOVE_FROM_LIST_CTA, { source: 'SRP' });
};

const onShowSignupModal = (source?: string) => {
    analytics.logEvent(analytics.AnalyticsEvent.EVTNM_SHOW_REGISTRATION_MODAL, {
        Forced: false,
        Source: source,
    });
};

const onShoppingCartExperienceRendered = () => {
    LocalStorage.setItem(StorableDataKeys.SRP_SHOPPING_CART_EXPERIENCE_SHOWED, true);
    logEvent(AnalyticsEvent.EVTNM_LOADED_SHOPPING_CARD_EXPERIENCE, { source: 'venues SRP' });
};

const onShoppingCartExperienceClose = () => {
    logEvent(AnalyticsEvent.EVTNM_CLICKED_SHOPPING_CARD_EXPERIENCE_CLOSE, { source: 'venues SRP' });
};

const onShoppingCartExperienceNext = () => {
    logEvent(AnalyticsEvent.EVTNM_CLICKED_SHOPPING_CARD_EXPERIENCE_NEXT, { source: 'venues SRP' });
};

/**
 * Error logging
 */
const logError = () => {
    if (window.location.pathname.indexOf('/wedding-venues') !== -1) {
        analytics.logEvent(analytics.AnalyticsEvent.EVTNM_USER_LOCAL_STORAGE_ERROR, { source: 'wedding venues SRP' });
    }
    if (window.location.pathname.indexOf('/hotels/search') !== -1) {
        analytics.logEvent(analytics.AnalyticsEvent.EVTNM_USER_LOCAL_STORAGE_ERROR, { source: 'Hotels search' });
    }
};

/**
 * Inner component for adding any business logic that requires access to the actual context
 */
const Inner = (props: React.PropsWithChildren<{}>) => {
    const { cartOpen } = React.useContext(ShoppingCartContext);
    return (
        <>
            {cartOpen && <Global preventScrolling='onlyMobile' />}
            {props.children}
        </>
    );
};

/**
 * Context provider wrapper that applies some defaults for this app
 * @param props
 */
const ShoppingCartContextProviderWrapper = (props: React.PropsWithChildren<{}>) => {
    return (
        <ShoppingCartContextProvider
            portalId={APP_ROOT_DOM_NODE_ID}
            cartType={CartType.VENUES}
            itemsMax={10}
            logError={logError}
            onCartOpen={onCartOpen}
            onSubmitCTAClick={onSubmitCTAClick}
            onSuccessfulOutreach={onSuccessfulOutreach}
            onItemRemoved={onItemRemove}
            onExperienceRendered={onShoppingCartExperienceRendered}
            onExperienceNext={onShoppingCartExperienceNext}
            onExperienceClose={onShoppingCartExperienceClose}
        >
            <Inner>{props.children}</Inner>
        </ShoppingCartContextProvider>
    );
};

export default ShoppingCartContextProviderWrapper;
